import React, { useEffect, useState } from "react";
import "./ReportOverdueInvoice.scss";
import { commaFormat } from "../../utils/Helper";
import { IInvoice } from "../../models/Dasboard";

interface ReportOverdueProps {
  overdueInvoices: IInvoice[];
}

const PER_PAGE = 4;

const ReportOverdueInvoice: React.FC<ReportOverdueProps> = ({
  overdueInvoices,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(overdueInvoices.length / PER_PAGE);

  const handlePagination = (pageNo: number) => {
    setCurrentPage(pageNo);
  };

  const openInvoiceUrl = (url: string) => {
    window.open(url, "_blank");
  };

  const startIndex = (currentPage - 1) * PER_PAGE;
  const currentInvoices = overdueInvoices.slice(
    startIndex,
    startIndex + PER_PAGE
  );

  return (
    <div className="overdue-invoice-main-container flex-1 py-12 flex-column gap-10">
      <p className="main-heading xetgo-font-tag bold px-10">Overdue Invoice</p>
      <div className="flex-column">
        <div className="overdue-invoice-grid heading-grid xetgo-font-tag bold px-10">
          <p className="py-6">Invoice Date</p>
          <p className="py-6 px-10">PO NO.</p>
          <p className="py-6 px-10">Invoice No.</p>
          <p className="py-6 px-10">Invoice Amount</p>
          <p className="py-6">Status</p>
        </div>

        <div className="all-invoices-container flex-1">
          {currentInvoices.length > 0 &&
            currentInvoices.map((invoice, index) => (
              <div
                key={index}
                className="invoice-container overdue-invoice-grid xetgo-font-tag px-10"
              >
                <p className="py-6">{invoice.date}</p>
                <p className="py-6 px-8">{invoice.po_number}</p>
                <p className="py-6 px-8">{invoice.invoice_number}</p>
                <p className="py-6 px-8">
                  ₹{commaFormat(invoice.amount.toString())}
                </p>
                <p className="py-6">{invoice.status}</p>
                <div className="flex-row align-items-center">
                  <img
                    onClick={() => openInvoiceUrl(invoice.url)}
                    className="cursor-pointer"
                    height={12}
                    width={12}
                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240904094334-download_purple.svg"
                    alt="download-icon"
                  />
                </div>
              </div>
            ))}
        </div>

        {totalPages > 1 && (
          <div className="flex-row align-items-center justify-content-center gap-6 mt-12">
            {Array.from({ length: totalPages }, (_, index) => (
              <p
                key={index}
                className={`pagination-dot cursor-pointer ${
                  currentPage === index + 1 ? "active-pagination" : ""
                }`}
                onClick={() => handlePagination(index + 1)}
              ></p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportOverdueInvoice;
